import React from "react";
import { Helmet } from "react-helmet";
import {
  Grid, Container, Box,
} from "@mui/material";
import RedirectList from "../../components/RedirectList";
import { mainBackgroundStyles } from "../../styles/common";

function Redirects() {
  return (
    <>
      <Helmet>
        <title>Redirect List</title>
      </Helmet>
      <Grid
        container
        spacing={0}
        sx={mainBackgroundStyles}
      >
        <Container maxWidth={false}>
          <Box mt={3} mb={3}>
            <RedirectList />
          </Box>
        </Container>
      </Grid>
    </>
  );
}

export default Redirects;
